// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__25Pl8","rootSmall":"AddTileButton_rootSmall__G6s7h"};